/** Password policy — keep in sync with acc.password_validation / AUTH_PASSWORD_VALIDATORS. */

export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_HAS_LOWER = /[a-z]/
export const PASSWORD_HAS_UPPER = /[A-Z]/
export const PASSWORD_HAS_DIGIT = /\d/
/** Any character that is not an ASCII letter or digit. */
export const PASSWORD_HAS_SPECIAL = /[^A-Za-z0-9]/

export const PASSWORD_RULE_KEYS = [
  'password.min_length',
  'password.need_lowercase',
  'password.need_uppercase',
  'password.need_digit',
  'password.need_special',
  'password.not_similar',
  'password.not_common',
] as const
